<template>
  <div>
    <van-tree-select
      height="92.4vh"
      :items="sortLeftData"
      :main-active-index.sync="active"
      @click-nav="sele_user"
    >
      <template #content>
        <div
          v-for="(category, categoryIndex) in sortLeftData"
          :key="categoryIndex"
        >
          <div class="box" v-if="active === categoryIndex">
            <template v-for="(item, index) in indexLeftData">
              <!-- 每一项商品 -->
              <div class="my_item" @click="go_type(item.id)" :key="index">
                <img class="my_img" :src="https + item.image" alt="" />
                <div>{{ item.title }}</div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </van-tree-select>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from "../../src/components/my_tabbar.vue";
import { sort, sortItem } from "../../src/utils/request";

import axios from "axios";
export default {
  data() {
    return {
      active: 0,
      https: "",
      indexLeftData: [],
      sortLeftData: [],
    };
  },
  methods: {
    //切换用户 右侧显示对应的商品
    async sele_user(index) {
      var id = this.sortLeftData[index].id;
      this.active = index;
      const res = await sortItem({ data: { id } });
      this.indexLeftData = res.data.data;
    },
    //跳转到详情页面
    go_type(value) {
      this.$router.push({
        path: "/shop_type",
        query:{
          id:value
        }
      });
    },
  },
  components: {
    Tabbar, //tabbar组件
  },
  async mounted() {
    this.https = axios.defaults.baseURL; //获取axios的baseURL
    //获取分类数据
    const res = await sort();
    var obj;
    //构造对应的数据结构
    res.data.data.forEach((item) => {
      obj = {};
      obj.text = item.title;
      obj.titles = item.titles;
      obj.id = item.id;
      this.sortLeftData.push(obj);
    });
    //右侧数据 默认获取sortLeftData数据的第一项
    this.indexLeftData = this.sortLeftData[0].titles;
  },
};
</script>

<style>
.van-sidebar {
  padding-top: 20px;
  box-sizing: border-box;
}
.van-tree-select__content {
  flex: 3 !important;
}
.van-sidebar-item--select {
  font-weight: 700 !important;
  font-size: 16px;
}
.new_p {
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.info {
  display: flex;
  justify-content: space-between;
  padding: 6px 4px;
}
.price {
  font-weight: 700;
}

.item {
  width: 47%;
  margin-bottom: 14px;
}

.intro {
  text-align: left;
  color: #909090;
  font-size: 10px;
  line-height: 16px;
  padding: 0px 4px;
}
.image {
  width: 163px;
  height: 196px;
  background: pink;
}
.van-sidebar-item {
  z-index: 999;
}
.box {
  padding: 14px;
  padding-top: 20px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}
.my_item {
  width: 30%;
  height: 110px;
  border-radius: 8px;
  color: #000;
  font-size: 15px;
  margin: 0 8.5px 50px 0;
}
.my_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>